import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../../hooks/redux';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames } from '../../../models/Common';

const SurveySuccess = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { isAuth } = useAppSelector((state) => state.authReducer);

  const handleClick = () => {
    const path = isAuth ? GlobalRouteNames.HomePage : GlobalRouteNames.LoginPage;
    history.push(path);
  };

  return (
    <div className="success-container">
      <h1 className="skeleton--disabled">{t('qualityAssessment.thanksForFeedback')}</h1>
      <p style={{ fontSize: '24px' }} className="skeleton--disabled">
        {t('qualityAssessment.helpImprove')}
      </p>
      <CustomMUIButton
        label={t('qualityAssessment.toMain')}
        handleClick={handleClick}
        className={ButtonClassNames.PrimaryFulfilled}
        isBold
      />
    </div>
  );
};

export default SurveySuccess;
